try {
    var wtype = window.performance.getEntriesByType("navigation")[0].type; 
    console.debug("CustomChat: navigation type: " + wtype);
    if (wtype == 'back_forward') {
        console.info("CustomChat: duplicated tab - discarding sessionID to prevent confusion with original tab");
        sessionStorage.removeItem("cc_sessionId");
    }
} catch (error) {
    console.debug("CustomChat: error checking navigation type: " + error);
}

sessionStorage.removeItem("cc_resumed");
var dataGlobal;
var lastWrite = localStorage.getItem("cc_lastWrite");
if (!lastWrite || (new Date().getTime() - Date.parse(lastWrite)) > 120000) {
    console.info("CustomChat: no current session found");
    // Last write was > 2 mins ago or not at all - new CC
    localStorage.removeItem("cc_lastWrite");
    localStorage.removeItem("cc_state");
    localStorage.removeItem("cc_sessionId");
    localStorage.removeItem("cc_extended");
    /*
     Following added because switching widgets seemed to somehow keep the old widget data before load completed in 
     EnterChatView when loaded in same IFrame (not related to persistence, discovered occurred in previous version
     too).  Therefore this flag tells EnterChatView the data is already loaded or wait for notification load has 
     completed rather than just check if a (loaded) data property exists.
    */
    localStorage.removeItem("cc_zipLoaded");
    lastWrite = undefined;    
}

var sessionId = sessionStorage.getItem("cc_sessionId");
if (!sessionId) {
    sessionId = Math.random().toString();
    sessionStorage.setItem("cc_sessionId", sessionId);
    console.info("CustomChat: session ID stored: " + sessionId);
}

if (lastWrite) {
    try {
        var state = JSON.parse(localStorage.getItem("cc_state"));
        if (state.appData.DataGlobal.connId !== -1) {
            dataGlobal = state.appData.DataGlobal;
            sessionStorage.setItem("cc_resumed", JSON.stringify(state.appData.DataGlobal));
            console.info("CustomChat: existing session active and resumable");
        }            
    } catch(err) {
        console.debug("CustomChat: error parsing state: " + err);    
    }
    if (!sessionStorage.getItem("cc_resumed")) {
        console.info("CustomChat: existing session active but not resumable - discarding");
        localStorage.removeItem("cc_lastWrite");
        localStorage.removeItem("cc_state");
        localStorage.removeItem("cc_sessionId");
        localStorage.removeItem("cc_extended");
        localStorage.removeItem("cc_zipLoaded");
        lastWrite = undefined;    
    }
}

// Whatever the scenario we are now the chat manager, and active tabs we resume from need to use this to know they are no longer the manager
localStorage.setItem("cc_sessionId", sessionId);

import { createApp } from "vue";
import App from "./App.vue";
import mitt from 'mitt';
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
//import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
//import "babel-polyfill";

import $ from "jquery";
window.jQuery = $;
require ("signalr");

store.commit("removeAlertFromArray", undefined);

const emitter = mitt();
const app = createApp(App);

app.config.globalProperties.$EventBus = emitter;
router.beforeEach((to, from) => {
    try {
        console.debug(`CustomChat: route changing to [${JSON.stringify(to)}] from [${JSON.stringify(from)}]`);
    } catch(err) {
        // JSON errors sometimes
        console.debug('CustomChat: route changing', to, from);
    }
});

app.use(router);
app.use(store);
app.use(vuetify);

store.commit("setReferrer", document.referrer);
store.commit("setCCUrl", window.location.href);
var mount = true;

if (dataGlobal && dataGlobal.connId && lastWrite && store.getters.isConnect) {
    console.info("CustomChat: existing session is a connected chat");
    console.debug("CustomChat: resumed chat data:" + JSON.stringify(dataGlobal));
    if (store.getters.isSCOverride) {
        console.warn("CustomChat: SC override enabled - resumption not supported!");
        try {
            sessionStorage.removeItem("cc_resumed");
            $("custom-chat").hide(); // hide me
            $("#chat-view").hide(); // hide me
            mount = false;
          } catch (err) {
            console.log("CustomChat: another session has taken control but could not unload this", err);
          }
    
        throw new Error("SC override enabled - resumption not supported!");
    } else {
        sessionStorage.setItem("cc_resumed", JSON.stringify(dataGlobal));
        // Just in case something in middle reset a value for active call - ensure cached copy of connection/event IDs is used
        store.commit("setCurrentPolling",0);
        store.commit("setConnId", dataGlobal.connId);
        store.commit("setLastEventId", dataGlobal.lastEventId);
        localStorage.setItem("cc_sessionId", sessionId); // Repeated just in case the other tab loop clashed + overwrote        
    }
} else {
    if (lastWrite) {
        console.info("CustomChat: existing session existed but now seems disconnected");    
        sessionStorage.removeItem("cc_resumed");
    }
    store.commit("setConnId", -1); // In case cached is connected but expired
}
router.replace({path:"/", replace:true});
if (mount) app.mount("#app");


